import React from 'react';
import { PhoneRow, PriceRow, TextRow, TypeRow, HyperLinkRow } from 'components';
import { Colors, PermissionsList, RolePermission } from 'utils';
import { COLLECT_LOAD } from '../../../store/collections/collections.types';

export const actionEnums = {
  COLLECT_RESERVE: 'COLLECT_RESERVE',
  COLLECT_LOAD: 'COLLECT_LOAD',
};
export const collectionHead = [
  { name: '', title: 'Company Name', custom: false },
  { name: '', title: 'Authority Number', custom: false },
  { name: '', title: 'Vendor Name', custom: false },
  { name: '', title: 'Phone Number', custom: false },
  { name: '', title: 'Status', custom: false },
  { name: '', title: 'Debt', custom: false },
  (RolePermission([PermissionsList.COLLECT_FROM_RESERVE?.code]) || RolePermission([ PermissionsList.COLLECT_FROM_LOAD?.code])) &&
  { name: '', title: 'Actions', custom: false },
];

export const collectionBody = [
  { rowText: (item) => <TextRow name={item?.companyName} /> },
  { rowText: (item) => <TextRow name={item?.docketNumber} /> },
  {
    rowText: (item) =>
      <HyperLinkRow
        name={`${item?.firstName} ${item?.lastName}`}
        href={RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) ? `/vendor/${item?.id}` : ''}
        checkPermission={item?.id ? RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) : null}
      />
  },
  // { rowText: (item) =>  <TextRow name={`${item?.firstName} ${item?.lastName}`} /> },
  { rowText: (item) => <PhoneRow phone={item?.phone} /> },
  { rowText: (item) => <TypeRow text={item?.status} /> },
  { rowText: (item) => <PriceRow info={item?.outstandingDebt} /> },
  (RolePermission([PermissionsList.COLLECT_FROM_RESERVE?.code]) || RolePermission([ PermissionsList.COLLECT_FROM_LOAD?.code])) &&
  {
    button: (fn, item) => <div className="align-center" style={{ gap: 16 }}>
      {RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.COLLECT_FROM_RESERVE?.code]) &&
        <button
          style={{ width: 148 }}
          onClick={() => fn(actionEnums.COLLECT_RESERVE)}
          className="blue-button"
        >
          Collect Reserve
        </button>
      }
      {RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.COLLECT_FROM_LOAD?.code]) &&
        <button
          style={{ background: Colors.ThemeGreen, width: 148 }}
          onClick={() => fn(actionEnums.COLLECT_LOAD)}
          className="blue-button"
        >
          Collect Loads
        </button>
      }
    </div>,
  },
];

export const ACTION_TYPE = 'GET_COLLECTIONS';
export const COLLECT_RESERVE_ACTION_TYPE = 'COLLECT_RESERVE';
export const COLLECT_LOAD_ACTION_TYPE = 'COLLECT_LOAD';

export const tabEnums = {
  ACTIVE: 'ACTIVE',
  HISTORY: 'HISTORY',
};

export const tabParams = [
  { name: 'Active', type: tabEnums?.ACTIVE },
  { name: 'History', type: tabEnums?.HISTORY },
];


export const collectionHistoryHead = [
  { name: '', title: 'Date', custom: false, rowWidth: '12%' },
  { name: '', title: 'Creator', custom: false, rowWidth: '15%' },
  { name: '', title: 'Vendor', custom: false, rowWidth: '15%' },
  // { name: '', title: 'Vendor Name', custom: false, rowWidth: '15%' },
  { name: '', title: 'Type', custom: false, rowWidth: '15%' },
  { name: '', title: 'Description', custom: false, rowWidth: '20%' },
  { name: '', title: 'Total', custom: false, rowWidth: '20%' },

];